import Page from '../../page';

export default class BusinessLinesEntry extends Page {
    constructor(...args) {
        super(...args);


    }




    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/business-lines/entry/business-lines-entry.js